export const PREDEFINED_COLORS = [
  { name: 'Red', hex: '#E74C3C' },
  { name: 'Orange', hex: '#FF8C00' },
  { name: 'Yellow', hex: '#F1C40F' },
  { name: 'Green', hex: '#2ECC71' },
  { name: 'Blue', hex: '#3498DB' },
  { name: 'Purple', hex: '#9B59B6' },
  { name: 'Gray', hex: '#8F8F8F' },
] as const;

export const DEFAULT_LABELS = [
  {
    position: 1,
    name: 'Respond',
    colorHex: '#E74C3C',
    description: 'Emails requiring a direct response or action from the recipient',
  },
  { position: 2, name: 'FYI', colorHex: '#FF8C00', description: "Informational emails that don't require a response" },
  {
    position: 3,
    name: 'Comment',
    colorHex: '#F1C40F',
    description: 'Discussion threads, feedback, or collaborative emails',
  },
  {
    position: 4,
    name: 'Notification',
    colorHex: '#3498DB',
    description: 'Automated system notifications, alerts, or confirmations',
  },
  {
    position: 5,
    name: 'Awaiting Reply',
    colorHex: '#9B59B6',
    description: 'Emails where the sender is waiting for someone else to respond',
  },
  {
    position: 6,
    name: 'Marketing',
    colorHex: '#2ECC71',
    description: 'Promotional content, newsletters, or sales emails',
  },
  { position: 7, name: 'Spam', colorHex: '#8F8F8F', description: 'Unsolicited or irrelevant emails' },
] as const;

export const MAX_LABEL_NAME_LENGTH = 50;
export const MAX_LABEL_DESCRIPTION_LENGTH = 200;
export const MAX_CONFIG_NAME_LENGTH = 100;
export const MAX_LABELS = 7;
